module.exports = "/images/logo.png?2942ba1af871ae12d240042b6db9e1be";